import * as F from 'reduker/fp-utils'
import entities from 'reduker/entities'

export const getNotifications = F.pipe(
  state => state.notifications.data,
  entities.getAsList,
)

export const getUnreadNotifications = state => state.notifications.count
